import React from 'react'
import { Link } from 'react-router-dom';
import { heroImages } from '../../helpers/heroImages';


export const HeroCard = ({
    id,
    superhero,
    publisher,
    alter_ego,
    first_appearance,
    characters
}) => {
    return (
        <div className="card mb-3 ms-3 g-0 mt-3" style={{maxWidth: 350}}>
            <div className="row">
                <div className="col-md-4">
                    <img src={ heroImages(`./${id}.jpg`).default} className="card-img" alt={superhero} />
                </div>
                <div className="col-md-8">
                    <div className="card-body">
                        <h5 className="card-title">{superhero}</h5>
                        <p className="card-text">{alter_ego}</p>
                        {
                            (alter_ego !== characters)
                            && <p> {characters}</p>
                        }
                        <p className="card-text">
                            <small className="text-muted"> {first_appearance}</small>
                        </p>
                        <Link to={`./hero/${id}`}>
                            Mas...
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    )
}
